import { type IDropdownItem } from 'shared/ui'
import { type GroupInbox } from 'entities/Inbox/model/GroupInbox'
import { type Inbox } from 'entities/Inbox/model/Inbox'
import { type ConversationMenuStore } from 'pages/conversations/ui/ConversationMenu'

const typeRemoveFromFolder = 'remove_from_folder'

type IActionRemoveFromFolder = {
  inbox: Inbox
  groupInbox?: GroupInbox
  item?: IDropdownItem
}

export const menuRemoveFromFolder = (): IDropdownItem => {
  return {
    id: typeRemoveFromFolder,
    iconL: 'remove',
    label: 'Remove from folder',
  }
}

export const actionRemoveFromFolder = async (
  { inbox, groupInbox, item }: IActionRemoveFromFolder,
  store: ConversationMenuStore
) => {
  if (item?.id === typeRemoveFromFolder) {
    store.handleDeleteTeamsGroupsByIdRemoveTeamById(inbox, groupInbox)
  }
}
